"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HueColorPicker = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
/**
 * Copyright (c) 2015 Case Sandberg
 * Copyrights licensed under the MIT License. See the accompanying LICENSE file for terms.
 */
var react_1 = tslib_1.__importStar(require("react"));
var utils_1 = require("../utils");
var HueColorPicker = /** @class */ (function (_super) {
    tslib_1.__extends(HueColorPicker, _super);
    function HueColorPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (e) {
            var change = utils_1.calculateHueChange(e, _this.props.initColor.h, _this.hueContainer.current);
            if (change && _this.props.onChange) {
                _this.props.onChange(change);
            }
        };
        _this.handleTouchChange = function (e) {
            _this.handleChange(e.nativeEvent);
        };
        _this.handleMouseDown = function (e) {
            _this.bindEventListeners();
            _this.handleChange(e.nativeEvent);
        };
        _this.handleMouseUp = function () {
            _this.unbindEventListeners();
        };
        _this.hueContainer = react_1.default.createRef();
        return _this;
    }
    HueColorPicker.prototype.componentWillUnmount = function () {
        this.unbindEventListeners();
    };
    HueColorPicker.prototype.getPointerStyle = function () {
        return {
            position: "absolute",
            left: (this.props.initColor.h * 100) / 360 + "%",
        };
    };
    HueColorPicker.prototype.bindEventListeners = function () {
        window.addEventListener("mousemove", this.handleChange);
        window.addEventListener("mouseup", this.handleMouseUp);
    };
    HueColorPicker.prototype.unbindEventListeners = function () {
        window.removeEventListener("mousemove", this.handleChange);
        window.removeEventListener("mouseup", this.handleMouseUp);
    };
    HueColorPicker.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "hue-picker hue-horizontal s-hue-picker", ref: this.hueContainer, onMouseDown: this.handleMouseDown, onMouseUp: this.handleMouseUp, onTouchMove: this.handleTouchChange, onTouchStart: this.handleTouchChange },
            react_1.default.createElement("div", { style: this.getPointerStyle() },
                react_1.default.createElement("div", { className: "color-picker-pointer s-color-picker-pointer" }))));
    };
    return HueColorPicker;
}(react_1.PureComponent));
exports.HueColorPicker = HueColorPicker;
//# sourceMappingURL=HueColorPicker.js.map